export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_SSO_CLIENT_ID, // From Azure App Registration
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_SSO_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AZURE_SSO_REDIRECT_URI, // Your redirect URI
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case 0:
            console.error(message);
            return;
          case 1:
            console.warn(message);
            return;
          case 2:
            console.info(message);
            return;
          case 3:
            console.debug(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

// Delegated Graph scopes — manage AD group members.
// GroupMember.ReadWrite.All → list / add / remove members
// User.Read.All → look up any user by email (needed for "Add User")
export const graphGroupRequest = {
  scopes: [
    "https://graph.microsoft.com/GroupMember.ReadWrite.All",
    "https://graph.microsoft.com/User.Read.All",
  ],
};
